import { VStack } from '@genial/components';
import { BoxBorder, Color, Spacing } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { Box } from 'native-base';
import React from 'react';

export const SectionOuterCard: React.FC<{
  children: React.ReactNode;
  withoutBottomPadding?: boolean;
}> = ({ children }) => {
  return useBreakpointValue({
    base: (
      <VStack w="full" space={Spacing['stack.xxs']}>
        {children}
      </VStack>
    ),
    sm: (
      <Box p={Spacing['inset.sm']} bgColor={Color['neutral.white']} borderRadius={BoxBorder.heavy}>
        <VStack w="full" space={Spacing['stack.xxs']}>
          {children}
        </VStack>
      </Box>
    ),
  });
};

SectionOuterCard.displayName = 'SectionOuterCard';
